import Swiper from 'swiper';
import {Navigation} from 'swiper/modules';
import './b2b/B2bCalculationForm';

if (typeof window.B2bOffersSlider === 'undefined') {
    window.B2bOffersSlider = class B2bOffersSlider {
        constructor() {
            this.slider = null;
            this.eventRegister();
            this.initSlider();
        }

        eventRegister() {
            // кнопки prev/next передаются в Swiper Navigation
        }

        initSlider() {
            const viewport = document.querySelector('[data-b2b-offers-viewport]');

            this.slider = new Swiper(viewport, {
                modules: [Navigation],
                wrapperClass: 'b2b-offers__list',
                slideClass: 'b2b-offers__slide',
                navigation: {
                    prevEl: document.querySelector('[data-b2b-offers-prev]'),
                    nextEl: document.querySelector('[data-b2b-offers-next]'),
                },
                slidesPerView: 'auto',
                spaceBetween: 20,
                watchOverflow: true,
                loop: false,
            });
        }
    };
}

function initB2bPage() {
    if (document.querySelector('[data-b2b-offers]')) {
        window.b2bOffersSlider = new window.B2bOffersSlider();
    }
    if (document.querySelector('[data-b2b-form]')) {
        window.b2bCalculationForm = new window.B2bCalculationForm();
    }
}

export {initB2bPage};
